import Api from "./api";

class SystemNotificationsApi {
    api = new Api();

    get() {
        return this.api.get('system-notifications/get');
    }
    markRead(itemId) {
        return this.api.post('system-notifications/mark-read', {
            itemId: itemId
        })
    }
    markAllRead() {
        return this.api.post('system-notifications/mark-all-read');
    }
}

export default new SystemNotificationsApi();
